import React, { useState } from 'react';
import InputField from '../../../../common/InputField';
import CommonCheckBox from '../../../../common/CommonCheckBox';
import SelectOption from '../../../../common/SelectOption';
import TimeRangePicker from '../../../../common/TimePicker/TimeRangePicker';
import { Form, Select } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import DedicatedDesk from '../DedicatedDesk/DedicatedDesk';

const PrivateOfficeOrBooth = ({index, form, activityId, name, currency, activity, isEdit}) => {
  
  const [selectedDays, setSelectedDays] = useState([]);
  const paymentOptions = useSelector(state => state.space?.paymentOptions?.data || []);

  const isVirtualOffice = name === 'WORK_VIR' || activity === 'WORK_VIR';

  const getPaymentOptionId = () => {
    const {id} = paymentOptions.find(i => i.name === 'Monthly');
    return id;
  }

  // Filter payment options based on workspace type
  const getFilteredPaymentOptions = () => {
    if (isVirtualOffice) {
      // For Virtual Office, only show Monthly
      return paymentOptions.filter(option => option.name === 'Monthly');
    } else {
      // For Private Office and Booth, show Daily, Weekly, and Monthly
      return paymentOptions.filter(i => i.name === 'Daily' || i.name === 'Weekly' || i.name === 'Monthly');
    }
  };

  return (
    <>
      <DedicatedDesk 
        form={form}
        index={index}
        activityId={activityId}
        name={name}
        currency={currency}
        paymentOptionId={getPaymentOptionId()}
        activity={activity}
        isEdit={isEdit}
        isVirtualOffice={isVirtualOffice}
        filteredPaymentOptions={getFilteredPaymentOptions()}
      />
    </>
  );
};

export default PrivateOfficeOrBooth;
